import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import type { Draft } from "immer";

type ImmerSet<T> = (fn: (state: Draft<T>) => void) => void;

type ImmerStateCreator<T> = (
  set: ImmerSet<T>,
  get: () => T,
) => T;

/**
 * Creates a zustand store with devtools + immer middleware.
 */
export function createStore<T>(name: string, initializer: ImmerStateCreator<T>) {
  return create<T>()(
    devtools(
      immer((set, get) => initializer(set as unknown as ImmerSet<T>, get)),
      { name },
    ),
  );
}

export type { ImmerSet };
